/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import idIcon from "@/src/assets/icons/progress/icon_progressbar_personal_data.svg";
import contractTerminationIcon from "@/src/assets/icons/progress/icon_progressbar_letter.svg";
import contractIcon from "@/src/assets/icons/progress/icon_progressbar_vertrag.svg";

const progressBarsteps = [
  {
    key: "contractTermination",
    name: "Kündigung",
    icon: contractTerminationIcon,
  },
  {
    key: "contract",
    name: "Arbeitsverhältnis",
    icon: contractIcon,
  },
  {
    key: "personal",
    name: "Persönliche Angaben",
    icon: idIcon,
  },

];

export default progressBarsteps;
